import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import './adminLogin.css';
import logo from '../../assets/icons/18.png';
import loginBg from '../../assets/icons/loginBg.png';

import { getAllFormPaths } from "./formsMenuTree";
function AdminLogin() {
  // Show admin profile image if already logged in (from localStorage)
  let profileImage = null;
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.image && user.image !== "") {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      profileImage = `${baseUrl}/uploads/${user.image}`;
    }
  } catch {}
  const navigate = useNavigate();
  const [login, setLogin] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogin((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      // Ensure trailing slash is handled
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const response = await axios.post(`${baseUrl}/api/admin/login`, login);
      if (response.data.success && response.data.data && response.data.data.token) {
        // Store token and user info in localStorage
        localStorage.setItem("token", response.data.data.token);
        // Always use the image from backend if present, else fallback to previous user image
        let userObj = { ...response.data.data };
        const prevUser = JSON.parse(localStorage.getItem("user"));
        if (!userObj.image && prevUser && prevUser.image) {
          userObj.image = prevUser.image;
        }
        localStorage.setItem("user", JSON.stringify(userObj));
        // Store userName for header dropdown (backend returns fullName)
        const name = userObj.fullName || userObj.name || userObj.first_name || userObj.email || "Admin";
        localStorage.setItem("userName", name);
        const roleLabel = { admin: "Admin", subAdmin: "Sub Admin", manager: "Manager", engineer: "Engineer" }[userObj.role] || userObj.role;
        toast.success(`Welcome, ${name} (${roleLabel})`);
        // Engineers have no dashboard - send them straight into the forms section.
        navigate(userObj.role === "engineer" ? (getAllFormPaths()[0] || "/admin") : "/admin/dashboard");
      } else {
        toast.error(response.data.message || "Invalid admin credentials");
      }
    } catch (error) {
      // If backend returns a response, show the backend message
      if (error.response && error.response.data && error.response.data.message) {
        const msg = error.response.data.message;
        toast.error(msg === "Account is deactivated" ? "This account is disabled. You cannot login. Contact your administrator." : msg);
      } else {
        toast.error("Server error. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-root">
      <div 
        className="admin-login-background"
        style={{ backgroundImage: `url(${loginBg})` }}
      >
        <div className="admin-login-overlay"></div>
      </div>
      
      <div className="admin-login-container">
        <form className="admin-login-form" onSubmit={handleSubmit}>
          <div className="admin-login-header">
            {profileImage ? (
              <img 
                src={profileImage} 
                alt="Admin Profile" 
                className="admin-login-logo"
                onError={e => { e.target.src = logo; }} 
              />
            ) : (
              <img 
                src={logo} 
                alt="OnSitePro Logo" 
                className="admin-login-logo"
              />
            )}
            <h2 className="admin-login-title">Admin Login</h2>
            <p className="admin-login-subtitle">Welcome back, please login to continue</p>
          </div>

          <div className="admin-login-input-group">
            <div className="admin-login-input-wrapper">
              <i className="fa fa-envelope admin-login-input-icon"></i>
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={login.email}
                onChange={handleChange}
                required
                className="admin-login-input"
                disabled={isLoading}
              />
            </div>
            
            <div className="admin-login-input-wrapper">
              <i className="fa fa-lock admin-login-input-icon"></i>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={login.password}
                onChange={handleChange}
                required
                className="admin-login-input admin-login-password-input"
                disabled={isLoading}
              />
              <button
                type="button"
                className="admin-login-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
              </button>
            </div>
          </div>

          <button 
            type="submit" 
            className="admin-login-btn"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="admin-login-spinner"></span>
                Logging in...
              </>
            ) : (
              'Login'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
